import img1 from '../images/blog/hesari.jpg';
import img2 from '../images/blog/ziaee.jpg';
import img3 from '../images/blog/katouzian.jpg';

import imgavatar1 from '../images/avatar/avt-01.png';
import imgavatar2 from '../images/avatar/avt-02.png';
import imgavatar3 from '../images/avatar/avt-03.png';

const data = [
    {
        id: 1,
        img: img1,
        title: 'Zohreh Hesari',
        desc: 'Zohreh Hesari is the CEO of NextGenPR, bringing visionary leadership and expertise in data-driven marketing strategies to the company. She is committed to revolutionizing personalized communication through innovative AI solutions, ensuring businesses can effectively connect with their target audiences.',
        imgavatar: imgavatar1,
        author: 'Cofounder & CEO',
        date: '04/10/2022',
    },
    {
        id: 2,
        img: img2,
        title: 'Pooneh Ziaee Abkenar',
        desc: 'Pooneh Ziaee Abkenar is the CTO of NextGenPR, a startup leveraging AI to offer innovative public relations services and intelligent agents that streamline PR processes and improve client interactions.',
        imgavatar: imgavatar2,
        author: 'Cofounder & CTO',
        date: '04/10/2022',
    },
    {
        id: 3,
        img: img3,
        title: 'Shaghayegh Katouzian',
        desc: 'Shaghayegh Katouzian, the CMO of NextGenPR, excels in crafting impactful marketing strategies and driving brand growth. With a passion for innovative solutions, she leads efforts to deliver personalized and engaging campaigns that resonate with diverse audiences.',
        imgavatar: imgavatar3,
        author: 'Cofounder & CMO',
        date: '04/10/2022',
    },

]

export default data;